import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
export const ModelContext = createContext({ model: {}, onPropertyChange: () => { } });
export const ModelContextProvider = ({ model, errors, onPropertyChange, disabled, children, }) => {
    const value = useMemo(() => {
        return { model, errors, onPropertyChange, disabled };
    }, [model, errors, onPropertyChange, disabled]);
    return _jsx(ModelContext.Provider, { value: value, children: children });
};
//# sourceMappingURL=ModelProvider.js.map